import DateHelper from '../helpers/date-helper';
import {
    INITIALISE_STATE, SELECT_APPOINTMENT_BY_ID, CHANGE_FILTER, SET_TV_PROPERTY_VALUE, SAVE_PERSONS, SELECT_PERSON_BY_ID,
    DELETE_PERSONS, SELECT_NEXT_PERSON_ID, FOTO_ADD, FOTO_REMOVE, SELECT_BOCK_BY_ID, SET_BOCK_VALUE, SAVE_TV_DATA, ADD_BOCK_TO_DB,
    SAVE_TV_DATA_BOCK, DELETE_BOCK_FROM_DB, SELECT_CURRENT_COMPANY, DRIVERS_LIST
} from '../actions/types';
import { SHOWN_TYPE_OFFENE } from '../helpers/constants';

const initialState = {
    days: [],
    appointments: [],
    bocks: [],
    positions: [],
    enteredData: [],
    persons: [],
    attachments: [],
    fotos: [],
    driverList: [],

    shownDay: (new DateHelper()).getTodayIndex(),
    shownType: SHOWN_TYPE_OFFENE,
    selectedAppointmentId: -1,
    selectedPersonId: -1,
    nextPersonId: -1,
    selectedBockId: -1,
    selectedCompanyId: -1 
}

export default function (state = initialState, action) {
    switch (action.type) {
        case INITIALISE_STATE:
            if (!action.allDbData) return state;
            return Object.assign({}, state, action.allDbData);
        case CHANGE_FILTER:
            return { ...state, shownType: action.payload };
        case SET_TV_PROPERTY_VALUE:
            {
                let edIndex = state.enteredData.findIndex(c => c.UniqueID === action.app.UniqueID);
                if (edIndex === -1) {
                    let newED = { UniqueID: action.app.UniqueID };
                    newED[action.prop] = action.value;
                    let newS = { ...state, enteredData: [...state.enteredData, newED] }
                    return newS;
                } else {
                    let enteredData = Object.assign([], state.enteredData);
                    let ed = Object.assign({}, enteredData[edIndex]);
                    ed[action.prop] = action.value;
                    enteredData.splice(edIndex, 1, ed);
                    let newS2 = { ...state, enteredData: enteredData };
                    return newS2;
                }
            }
        case SAVE_PERSONS:
            let personIndex = state.persons.findIndex(c => c.id === action.persons.id);
            if (personIndex === -1) {
                let newS = { ...state, persons: [...state.persons, action.persons] }
                return newS;
            } else {
                let personsData = Object.assign([], state.persons);
                let ed = Object.assign({}, personsData[personIndex]);
                ed = action.persons;
                personsData.splice(personIndex, 1, ed);
                let newS2 = { ...state, persons: personsData };
                return newS2;
            }
        case DELETE_PERSONS:
            let personsWithoutDeletedOnes = state.persons.filter(c => c.id !== action.idToDelete);
            let newS = { ...state, persons: [...personsWithoutDeletedOnes] }
            return newS;
        case SELECT_APPOINTMENT_BY_ID:
            return { ...state, selectedAppointmentId: action.UniqueID };
        case SELECT_CURRENT_COMPANY:
                return { ...state, selectedCompanyId: action.IdFirma };
        case SELECT_PERSON_BY_ID:
            return { ...state, selectedPersonId: action.Id };
        case SELECT_NEXT_PERSON_ID:
            return { ...state, nextPersonId: action.Id };
        case FOTO_ADD:
            let fotos = state.fotos.slice();
            fotos.push(action.payload);
            return { ...state, fotos: fotos }
        case FOTO_REMOVE:
            return { ...state, fotos: state.fotos.filter(f => f.id !== action.payload) }
        case SELECT_BOCK_BY_ID:
            return { ...state, selectedBockId: action.UniqueID };
        case SET_BOCK_VALUE:
            {
                let edIndex = state.bocks.findIndex(c => c.id === action.app.id);
                if (edIndex === -1) {
                    let newED = { id: action.app.id };
                    newED[action.prop] = action.value;
                    let newS = { ...state, bocks: [...state.bocks, newED] }
                    return newS;
                } else {
                    let bocksData = Object.assign([], state.bocks);
                    let ed = Object.assign({}, bocksData[edIndex]);
                    ed[action.prop] = action.value;
                    bocksData.splice(edIndex, 1, ed);
                    let newS2 = { ...state, bocks: bocksData };
                    return newS2;
                }
            }
        // case SAVE_TV_DATA:
        //     let edIndex = state.enteredData.findIndex(c=> c.UniqueID===action.app.UniqueID);
        case SAVE_TV_DATA:
            let edIndex = state.enteredData.findIndex(c => c.UniqueID === action.app.UniqueID);

            if (edIndex === -1) {
                let newS = { ...state, enteredData: [...state.enteredData, action.enteredData] }
                return newS;
            } else {
                let enteredData = Object.assign([], state.enteredData);
                enteredData.splice(edIndex, 1, action.enteredData);
                let newS2 = { ...state, enteredData: enteredData };
                return newS2;
            }
        case SAVE_TV_DATA_BOCK:
                let bockIndex = state.bocks.findIndex(c => c.id === action.app.id);

                // if (edIndex === -1) {
                //     let newS = { ...state, enteredData: [...state.enteredData, action.enteredData] }
                //     return newS;
                // } else {
                    let enteredData = Object.assign([], state.bocks);
                    enteredData.splice(bockIndex, 1, action.app);
                    let newS2 = { ...state, bocks: enteredData };
                    return newS2;
                // }

        case ADD_BOCK_TO_DB:{
            let newS = { ...state, bocks: [...state.bocks, action.bock] }
            return newS;
        }
        case DELETE_BOCK_FROM_DB:
            let bocksWithoutDeletedOnes = state.bocks.filter(c => c.id !== action.idToDelete);
            let afterBockDelete = { ...state, bocks: [...bocksWithoutDeletedOnes] }
            return afterBockDelete; 
        case DRIVERS_LIST:
            return { ...state, driverList: action.payload}

        default:
            return state;
    }
}